<template>
  <v-card>
    <v-card-text>
      <form data-vv-scope="benefitForm">
        <v-flex xs12>
          <message :messages="messages"></message>
        </v-flex>
        <v-layout row wrap>
          <v-flex xs6>
            <v-subheader class="queryLabel">{{labels.scheme}}</v-subheader>
            <div class="title">{{this.$store.state.parameters.scheme.schemeMenu.sideMenuTitle}}</div>
          </v-flex>
          <v-flex xs6 v-if="!newBenefit">
            <v-subheader class="queryLabel">{{labels.planNo}}</v-subheader>
            <div class="title">{{benefitForm.planNo}}</div>
          </v-flex>
          <v-flex xs6 v-else>
            <v-autocomplete data-vv-scope="benefitForm" :items="planList" v-model="benefitForm.planNo" :label="labels.planNo" item-text="label" item-value="value" :error-messages="errors.collect('benefitForm.planNo')" data-vv-name="planNo" :data-vv-as="labels.planNo" v-validate="'required'" :loading="planLoading"></v-autocomplete>
          </v-flex>
          <v-flex xs6  v-if="!newBenefit">
            <v-subheader class="queryLabel">{{labels.benefitQuery}}</v-subheader>
            <div class="title">{{benefitForm.benefit}}</div>
          </v-flex>
          <v-flex xs6 v-else>
            <v-autocomplete data-vv-scope="benefitForm" :items="benefitList" v-model="benefitForm.benefit" :label="labels.benefit" item-text="label" item-value="value" :error-messages="errors.collect('benefitForm.benefit')" data-vv-name="benefit" :data-vv-as="labels.benefit" v-validate="'required'"></v-autocomplete>
          </v-flex>
          <v-flex xs6  v-if="!newBenefit">
            <v-subheader class="queryLabel">{{labels.busCls}}</v-subheader>
            <div class="title">{{benefitForm.busCls}}</div>
          </v-flex>
          <v-flex xs6 v-else>
            <v-autocomplete data-vv-scope="benefitForm" :items="busClsList" v-model="benefitForm.busCls" :label="labels.busCls" item-text="label" item-value="value" :error-messages="errors.collect('benefitForm.busCls')" data-vv-name="busCls" :data-vv-as="labels.busCls" v-validate="'required'"></v-autocomplete>
          </v-flex>
          <v-flex xs6  v-if="!newBenefit">
            <v-subheader class="queryLabel">{{labels.tarf}}</v-subheader>
            <div class="title">{{benefitForm.tarf}}</div>
          </v-flex>
          <v-flex xs6 v-else>
            <v-autocomplete data-vv-scope="benefitForm" :items="tarfList" v-model="benefitForm.tarf" :label="labels.tarf" item-text="label" item-value="value" :error-messages="errors.collect('benefitForm.tarf')" data-vv-name="tarf" :data-vv-as="labels.tarf" v-validate="'required'"></v-autocomplete>
          </v-flex>
          <v-flex xs6>
            <v-text-field data-vv-scope="benefitForm" v-model="benefitForm.napSubLevel" :label="labels.napSubLevel" :error-messages="errors.collect('benefitForm.napSubLevel')" data-vv-name="napSubLevel" :data-vv-as="labels.napSubLevel" v-validate="'required|numeric|max:10'"></v-text-field>
          </v-flex>
          <v-flex xs6 v-if="!newBenefit">
            <cal-picker data-vv-scope = "benefitForm" :label="labels.effDate" v-model="benefitForm.effDate" :error-messages="errors.collect('benefitForm.effDate')" data-vv-name="effDate" :data-vv-as="labels.effDate" v-validate="'required'" readonly></cal-picker>
          </v-flex>
          <v-flex xs6 v-else>
            <cal-picker data-vv-scope = "benefitForm" :label="labels.effDate" v-model="benefitForm.effDate" :error-messages="errors.collect('benefitForm.effDate')" data-vv-name="effDate" :data-vv-as="labels.effDate" v-validate="'required'"></cal-picker>
          </v-flex>
          <v-flex xs6>
            <cal-picker data-vv-scope = "benefitForm" :label="labels.expDate" v-model="benefitForm.expDate" :error-messages="errors.collect('benefitForm.expDate')" data-vv-name="expDate" :data-vv-as="labels.expDate" :min="benefitForm.effDate"></cal-picker>
          </v-flex>
          <v-flex xs6>
            <v-autocomplete data-vv-scope="benefitForm" :items="gapCalcMethodList()" v-model="benefitForm.gapCalcMethod" :label="labels.gapCalcMethod" item-text="label" item-value="value" :error-messages="errors.collect('benefitForm.gapCalcMethod')" data-vv-name="gapCalcMethod" :data-vv-as="labels.gapCalcMethod" v-validate="'required'"></v-autocomplete>
          </v-flex>
          <v-flex xs6>
            <v-text-field data-vv-scope="benefitForm" v-model="benefitForm.basedUom" :label="labels.basedUom" :error-messages="errors.collect('benefitForm.basedUom')" data-vv-name="basedUom" :data-vv-as="labels.basedUom" v-validate="'required|numeric|max:10'"></v-text-field>
          </v-flex>
        </v-layout>
      </form>
    </v-card-text>
    <v-card-actions>
      <v-btn color="primary" type="submit" :loading="submitting" @click.prevent="doSaveBenefitForm">
        {{newBenefit ? 'Save Benefit' : 'Update Benefit'}}
        <v-icon right>{{newBenefit ? 'mdi-plus' : 'mdi-content-save'}}</v-icon>
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import FieldMixin from '@/mixins/field'
import MessageMixin from '@/mixins/message'
import { pkgGapCalcMethod } from '@/const/underwriting/package'
import { expandURI } from '@/utils/ajax'
import { extractMenu } from '@/utils/extract'
export default {
  data() {
    return {
      labels: {
        busCls: 'Business Class*',
        tarf: 'Tariff*',
        scheme: 'Scheme',
        benefit: 'Benefit*',
        benefitQuery: 'Benefit',
        gapCalcMethod: 'GAP Calculation Method*',
        benType: 'Benefit Type*',
        napSubLevel: 'NAP Sub Level*',
        addBen: 'Add Benefit',
        defBen: 'Default Benefit',
        minSi: 'Minimum Sum Insured',
        maxSi: 'Maximum Sum Insured',
        protSi: 'Protect Sum Insured',
        basedUom: 'Based Unit Of Measure*',
        expDate: 'Expired Date',
        effDate: 'Effective Date*',
        planNo: 'Plan No*'
      },
      benefitForm: {
        busCls: null,
        busClsDesc: null,
        planNoDesc: null,
        tarfDesc: null,
        tarf: null,
        benefitDesc: null,
        schemeDesc: null,
        benefit: null,
        scheme: null,
        planNo: null,
        gapCalcMethod: null,
        napSubLevel: null,
        basedUom: null,
        expDate: null,
        effDate: null
      },
      planList: [],
      tarfList: [],
      busClsList: [],
      loading: false,
      submitting: false,
      newBenefit: null,
      planLoading: false,
      menu: []
    }
  },
  watch: {
    'ids.benefit': function (value) {
      Promise.all([this.doBenefitInit(), this.doBusClsList(), this.doTarfList(), this.doPlanList(this.ids.scheme)])
      if (value !== 'new') {
        this.resetValidator()
        this.resetMessages()
        this.newBenefit = false
        if (value !== null) {
          this.fetchForm(value)
        }
      } else {
        this.newBenefit = true
        this.doClearForm()
      }
    }
  },
  computed: {
    schemeMenu() {
      return this.$store.state.parameters.scheme.schemeMenu.menu
    }
  },
  methods: {
    async fetchForm(benefit) {
      const apiURI = this.schemeMenu.pkgTarfBen
      if (apiURI) {
        try {
          const expand = {
            scheme: this.ids.scheme,
            planNo: this.ids.planNo,
            busCls: this.ids.busCls,
            tarf: this.ids.tarf,
            benefit: benefit,
            effDate: this.ids.benEffDate
          }
          const result = await this.$http.get(expandURI(apiURI, expand))
          const { data } = result.data
          if (data) {
            this.benefitForm.scheme = data.pkgTarfBen.scheme
            this.benefitForm.planNo = data.pkgTarfBen.planNo
            this.benefitForm.tarf = data.pkgTarfBen.tarf
            this.benefitForm.benefit = data.pkgTarfBen.benefit
            this.benefitForm.busCls = data.pkgTarfBen.busCls
            this.benefitForm.effDate = data.pkgTarfBen.effDate
            this.benefitForm.expDate = data.pkgTarfBen.expDate
            this.benefitForm.gapCalcMethod = data.pkgTarfBen.gapCalcMethod
            this.benefitForm.napSubLevel = data.pkgTarfBen.napSubLevel
            this.benefitForm.basedUom = data.pkgTarfBen.basedUom

            this.menu = extractMenu(result.data._links)
          }
        } catch (err) {
          console.log(err)
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      } else {
        this.errorMessage('Invalid API Url')
      }
    },
    async doBenefitInit() {
      const apiURI = this.schemeMenu.benefitList
      if (apiURI) {
        const result = await this.$http.get(apiURI)
        const { data } = result.data
        if (data) {
          this.benefitList = []
          this.benefitList = data.benefitList
        } else {
          this.benefitList = []
        }
      }
    },
    gapCalcMethodList() {
      const list = Object.freeze(pkgGapCalcMethod)
      let convertArray = Object.keys(list).map(key => {
        return {
          label: key + ' - ' + list[key],
          value: key
        }
      })
      return convertArray
    },
    async doBusClsList() {
      const apiURI = this.schemeMenu.busClsList
      if (apiURI) {
        const result = await this.$http.get(apiURI)
        const { data } = result.data
        if (data) {
          this.busClsList = []
          this.busClsList = data.pkgBusClsList
        } else {
          this.busClsList = []
        }
      } else {
        this.busClsList = []
        this.errorMessage('Invalid API Url - Business Class List')
      }
    },
    async doTarfList() {
      const apiURI = this.schemeMenu.tarfList
      if (apiURI) {
        const result = await this.$http.get(apiURI)
        const { data } = result.data
        if (data) {
          this.tarfList = []
          this.tarfList = data.pkgTarfList
        } else {
          this.tarfList = []
        }
      } else {
        this.tarfList = []
        this.errorMessage('Invalid API Url - Tariff List')
      }
    },
    async doPlanList(xscheme) {
      const apiURI = this.schemeMenu.planList
      const expand = {
        scheme: xscheme
      }
      if (apiURI) {
        const result = await this.$http.get(expandURI(apiURI, expand))
        const { data } = result.data
        if (data) {
          this.planList = data.planList
        } else {
          this.planList = []
        }
      } else {
        this.planList = []
        this.errorMessage('Invalid API Url - Plan List')
      }
    },
    doClearForm() {
      this.resetValidator()
      this.resetMessages()
      this.benefitForm.scheme = this.ids.scheme
      this.benefitForm.planNo = null
      this.benefitForm.tarf = null
      this.benefitForm.busCls = null
      this.benefitForm.benefit = null
      this.benefitForm.benefitDesc = null
      this.benefitForm.gapCalcMethod = null
      this.benefitForm.benType = null
      this.benefitForm.benTypeDesc = null
      this.benefitForm.napSubLevel = null
      this.benefitForm.basedUom = null
      this.benefitForm.expDate = null
      this.benefitForm.effDate = null
    },
    doSaveBenefitForm() {
      this.resetMessages()
      this.$validator.validateAll('benefitForm').then(result => {
        if (result) {
          if (this.newBenefit) {
            this.doCreateBenefitForm()
          } else {
            this.doUpdateBenefitForm()
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doCreateBenefitForm() {
      const apiURI = this.schemeMenu.pkgTarfBenCreate
      if (apiURI) {
        try {
          const result = await this.$http.post(apiURI, this.benefitForm)
          const { data } = result
          if (data) {
            this.notify(data)
            this.doClearForm()
            this.$emit('resetTab')
          }
        } catch (error) {
          const { data } = error.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      } else {
        this.errorMessage('Invalid API Url')
      }
    },
    async doUpdateBenefitForm() {
      const apiURI = this.menu.pkgTarfBenUpdate
      this.sumbitting = true
      if (apiURI) {
        try {
          const result = await this.$http.put(apiURI, this.benefitForm)
          const { data } = result
          if (data) {
            this.notify(data)
            this.sumbitting = false
          }
        } catch (error) {
          const { data } = error.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.sumbitting = false
        }
      } else {
        this.errorMessage('Invalid API Url')
        this.sumbitting = false
      }
    }
  },
  mounted() {
    if (this.newBenefit) {
      this.doClearForm()
    }
    Promise.all([this.doBenefitInit()])
  },
  props: {
    ids: {
      type: Object,
      default () {
        return {
          scheme: null,
          planNo: null,
          benefit: null
        }
      }
    }
  },
  mixins: [
    FieldMixin,
    MessageMixin
  ]
}
</script>

<style>

</style>
